import { User as UserProfile } from '../../../shared/service/user.service';

/**
 * Briques de SMS partagées entre les écrans CAC (comparateur, historique projets,
 * transactions, contacts).
 *
 * Chaque écran conserve sa propre construction de la salutation
 * (« Cher M. DUPONT, ») ; le corps et la signature sont mutualisés ici.
 */

/** Signature dynamique de l'agent connecté, commune aux SMS CAC. */
export function buildAgentSignature(agent: UserProfile): string {
  const lines: string[] = [];
  const name = (agent.username || '').trim();
  if (name) lines.push(name);
  if (agent.telephone_fixe) lines.push(agent.telephone_fixe.trim());
  if (agent.telephone) lines.push(agent.telephone.trim());
  if (agent.email) lines.push(agent.email.trim());
  lines.push('Cabinet BROKINS');
  lines.push('www.brokins.fr');
  return lines.join('\n');
}

/** Profil de repli quand le profil agent n'a pas pu être chargé. */
export const FALLBACK_AGENT_PROFILE: UserProfile = {
  id: 0, username: '', email: '', is_active: true, role: 'USER', createdAt: null,
};

/**
 * SMS de relance « simulations à jour » : envoyé quand on (re)transmet des devis
 * à un client déjà sollicité — action de renvoi explicite, ou projet créé il y a
 * plus de 6 mois.
 */
export const SMS_RELANCE_SIMULATIONS_BODY =
  "Nous vous avions envoyés plusieurs simulations d'économies sur votre taux d'assurance de prêt il y a quelques temps.\n"
  + "Si votre besoin est toujours d'actualité, je viens de vous renvoyer les simulations à jour dans un nouvel email. N'hésitez pas à vérifiez vos SPAMS (indésirables).\n"
  + "Le cas échéant, pouvons-nous échanger 5 minutes ?";
